import { create } from 'apisauce'
import backendAPI from './httpCommon'

export const taskAPI = create({
    baseURL: import.meta.env.VITE_APP_TASKDB_BACKEND,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'X-Requested-With',
    },
    timeout: 120000,
})
export const taskAPIDownload = create({
    baseURL: import.meta.env.VITE_APP_TASKDB_BACKEND,
    responseType: 'blob',
    headers: {
        Accept: 'application/zip',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'X-Requested-With',
    },
    timeout: 10000,
})
/**
 * WhoAmI
 */
export async function getWhoami() {
    let res = await backendAPI.get('/gviz/whoami').then((rs) => (rs.ok ? rs.data : false))
    return res
}
//#region Read
/**
 * Get Fields
 */
export const getFields = async (cIds, expandData) => {
    const res = await taskAPI.post('/getfields', cIds, expandData)
        .then((rs) => (rs.ok ? rs.data : rs.ok))

    if(res === null || res === undefined)
        return []
    return res
}

export const getDisabledFields = async (cIds) => {
    const res = await taskAPI.post('/getdisabledfields', cIds)
        .then((rs) => (rs.ok ? rs.data : rs.ok))

    if(res === null || res === undefined)
        return []
    return res
}

/**
 * Get Field Details
 */
export const getField = async (id) => {
    const res = await taskAPI.get(`/getfield/${id}`).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

/**
 * Get all field infos as zip file
 */
export const downloadFieldDataZip = async (id) => {
    const res = await taskAPIDownload.get(`/getfield/${id}`).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

/**
 * Get only field outer border as zip file
 */
export const downloadFieldBorderZip = async (id) => {
    const res = await taskAPIDownload.get(`/field/${id}/border`).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

/**
 * Get a specific field with expansions
 */
export const getFieldWithExpansions = async (id, expansions = []) => {
    // Build query string for each expansion
    const params = expansions.map(e => `expand_data=${encodeURIComponent(e)}`).join('&')
    const res = await taskAPIDownload.get(`/getfield/${id}?${params}`).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

/**
 * Get field path statistics
 */
export const getFieldPathStatistics = async (id) => {
    const res = await taskAPI.get(`/field/${id}/path-statistics`).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

/**
 * Get Tasks
 * Optionally filtered by period.
 * period: "7d" | "30d" | "90d" | "6m" | "1y" | "all"
 */
export const getTasks = async (fieldId, period) => {
    const query = period && period !== 'all' ? `?period=${encodeURIComponent(period)}` : ''
    const res = await taskAPI.get(`/gettasks/${fieldId}${query}`).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

/**
 * Get a task by name
 */
export const getTaskByName = async (fieldId, name) => {
    const res = await taskAPI.get(`/field/${fieldId}/task-by-name?name=${encodeURIComponent(name)}`)
        .then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

/**
 * Get disabled Tasks
 */
export const getDisabledTasks = async (fieldId) => {
    const res = await taskAPI.post(`/field/${fieldId}/disabledtasks`).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

/**
 * Get Task Details
 */
export const getTask = async (id) => {
    const res = await taskAPI.get(`/gettask/${id}`).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}
/**
 * Get Task ISO Data
 */
export const downloadISODataFromTask = async (id) => {
    const res = await taskAPIDownload.get(`/downloadtask/${id}`).then((rs) => rs)
    return res
}

/**
 * Download latest field work data
 */
export const downloadLatestWorkDataFromField = async (fieldId, work_type) => {
    const res = await taskAPIDownload.get(`/field/${fieldId}/latest-work-data/${work_type}/download`).then((rs) => rs)
    return res
}

/**
 * Get latest field work data
 */
export const getLatestWorkDataFromField = async (fieldId, workType) => {
    const res = await taskAPI.get(`/field/${fieldId}/latest-work-data/${workType}?max_points=100000`).then((rs) => rs)
    return res
}

/**
 * Get Plans
 */
export const getPlans = async (taskId) => {
    // const res = await taskAPI.get(`/getplans/${taskId}?expand_data=path_length&expand_data=path_working_area`).then((rs) => (rs.ok ? rs.data : rs.ok))
    const res = await taskAPI.get(`/getplans/${taskId}`).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

/**
 * Get Plan Details
 */
export const getPlan = async (id) => {
    const res = await taskAPI.get(`/getplan/${id}?expand_data=path_length&expand_data=path_working_area`).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

/**
 * Get all active plans for a field
 */
export const getFieldPlans = async (fieldId) => {
    const res = await taskAPI.get(`/field/${fieldId}/active-plans`).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}
//#endregion

//#region Create
/**
 * Create Field
 */
export const createField = async (data) => {
    const res = await taskAPI.post('/gviz/savefield', data).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

/**
 * Create Task
 */
export const createTask = async (data) => {
    const res = await taskAPI.post('/savetask', data).then((rs) => (rs))
    return res
}

/**
 * Create Plan
 */
export const createPlan = async (data) => {
    const res = await taskAPI.post(`/saveplan`, data)
    return res.ok ? res.data : res
}

//#endregion

//#region Update

/**
 * Update Field
 */
export const updateField = async (data) => {
    const res = await taskAPI.patch(`/updatefield`, data).then((rs) => (rs.ok ? rs.data : rs))
    return res
}

/**
 * Update Task
 */
export const updateTask = async (data) => {
    const res = await taskAPI.patch(`/updatetask`, data).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

/**
 * Update Plan
 */
export const updatePlan = async (data) => {
    const res = await taskAPI.patch(`/updateplan`, data).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

/**
 * Delete Field
 */
export const disableFieldAPI = async (id) => {
    const res = await taskAPI.delete(`/field/${id}`)
    if (res.status === 204) {
        return true
    }
    return false
}

/**
 * Get Field Change Infos
 */
export const getFieldChangeInfos = async (id) => {
    const res = await taskAPI.get(`/field/${id}/changes`).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

/**
 * Get vehicles
 */
export const getVehicles = async () => {
    const res = await taskAPI.get(`/vehicles`).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

/**
 * Get vehicles positions
 */
export const getVehiclesPositions = async (vehicle_serial, startTime, endTime) => {
    const params = new URLSearchParams()
    // If start_time is None, only the latest position entry per machine is returned (LIVE mode).
    if (startTime) {
        params.set('start_time', startTime)
    }
    // If end_time is None, all entries up to the current time are returned.
    if (endTime) {
        params.set('end_time', endTime)
    }
    const query = params.toString()
    const url = `/machine/${vehicle_serial}/positions${query ? `?${query}` : ''}`
    const res = await taskAPI.get(url).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

/**
 * Get organization implements
 */
export const getOrgImplements = async () => {
    const res = await taskAPI.get(`/implements`).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

/**
 * Set vehicle membership (move a vehicle from one organization to another)
 */
export const postSetVehicleMembership = async (data) => {
    const res = await taskAPI.post(`/set_vehicle_membership`, data).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

/**
 * Trigger resync of a vehicle/machine
 */
export const postTriggerResync = async (vehicle_serial) => {
    const res = await taskAPI.post(`/vehicle/${vehicle_serial}/trigger_resync`).then((rs) => rs.ok)
    return res
}

/**
 * Get Yield Data From Task
 */
export const getYieldDataFromTask = async (taskId) => {
    // add a default max_points=100.000 parameter to the query string to prevent memory issues
    const res = await taskAPI.get(`/task/${taskId}/yieldmap?max_points=100000`).then((rs) => rs)
    return res
}

/**
 * Get Parking lots
 */
export const getParkingLots = async (farm_id) => {
    const res = await taskAPI.get(`/farm/${farm_id}/parking-lots`).then((rs) => rs)
    return res
}

/**
 * Get Planned Parking Slots
 */
export const getPlannedParkingSlots = async (farm_id) => {
    const res = await taskAPI.get(`/farm/${farm_id}/planned-parking-slots`).then((rs) => rs)
    return res
}

/**
 * Delete a planned parking slot.
 */
export const deletePlannedParkingSlot = async (farm_id, planned_parking_slot_id) => {
    const res = await taskAPI
        .delete(`/farm/${farm_id}/planned-parking-slot/${planned_parking_slot_id}`)
        .then((rs) => rs)

    return res.status === 204
}

/**
 * Update planned parking slots (border, path, name, active).
 */
export const updatePlannedParkingSlots = async (farm_id, data) => {
    const res = await taskAPI.put(`/farm/${farm_id}/planned-parking-slot`, data).then((rs) => rs)
    return res
}

/**
 * Save a new Planned Parking Slot
 */
export const saveNewPlannedParkingSlot = async (farm_id, data) => {
    const res = await taskAPI.post(`/farm/${farm_id}/planned-parking-slot`, data).then((rs) => rs)
    return res
}

/**
 * Update a Parking Lot
 */
export const updateParkingLot = async (farm_id, data) => {
    const res = await taskAPI.put(`/farm/${farm_id}/parking-lot`, data).then((rs) => rs)
    return res
}

/**
 * Delete Old Parking Lot.
 * This endpoint is used to delete a parking lot and all its borders and paths.
 */
export const deleteParkingLot = async (farm_id, parking_lot_id) => {
    const res = await taskAPI.delete(`/farm/${farm_id}/parking-lot/${parking_lot_id}`).then((rs) => rs)
  
    return res.status === 204
}

/**
 * Get the machines and booms that worked on a given task
 */
export const getMachinesAndBoomsFromTask = async (taskId) => {
    const res = await taskAPI.get(`/task/${taskId}/participants`).then((rs) => (rs))
    return res
}

/**
 * Get as-applied map entries for a given task, optionally filtered by machine and boom.
 */
export const getAsAppliedMapEntriesFromTask = async (fieldId, taskId, machineId, boomId) => {
    let params = `?field_id=${fieldId}`
    if (machineId != null && machineId !== '') {
        params += `&machine_id=${machineId}`
    }
    if (boomId != null && boomId !== '') {
        params += `&boom_id=${boomId}`
    }
    const res = await taskAPI.get(`/task/${taskId}/as-applied-map${params}`).then((rs) => (rs))
    return res
}

//#endregion
